/**
 * Constants for Gate Deviation Dialog
 */

// Chart configuration constants
export const CHART_CONSTANTS = {
  // Animation and timing
  CHART_RESIZE_DELAY: 300,
  EXPORT_SCALE: 2,

  // Chart styling
  CENTER_LINE_COLOR: '#000',
  GRID_LINE_COLOR: 'rgba(0, 0, 0, 0.1)',
  CENTER_LINE_WIDTH: 2,
  GRID_LINE_WIDTH: 1,
  POINT_RADIUS: 8,

  // Background colors
  TOOLTIP_BACKGROUND: 'rgba(0, 0, 0, 0.8)',
  EXPORT_BACKGROUND: '#ffffff',

  // Chart dimensions and spacing
  MIN_CHART_HEIGHT: 500,
  TOOLTIP_OFFSET: 10,
} as const;

// Point marker styles
export const MARKER_STYLES = {
  SAME_DIRECTION: 'circle',
  OPPOSITE_DIRECTION: 'triangle',
} as const;

// Export settings
export const EXPORT_SETTINGS = {
  FORMAT: 'image/jpeg',
  QUALITY: 1.0,
  FILE_PREFIX: 'gate-deviation-chart',
} as const;
